// removed by extract-text-webpack-plugin
module.exports = {"Choose":"Choose___7b7MK","backer":"backer___1LXUr","label":"label___3waB0","select":"select___3V1XI","schemas":"schemas___E1cuQ"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditorGUI/Choose/styles.scss
// module id = 452
// module chunks = 0